import type { JSX } from 'react';

import type { SkillResource } from '@/lib/api/skills.js';

/** Read-only instructions of a skill version, with the paths of its files under them. */
export function SkillContentPreview({
  instructions,
  resources,
}: {
  instructions: string;
  resources: SkillResource[] | null;
}): JSX.Element {
  return (
    <div className="flex flex-col gap-2">
      <p className="whitespace-pre-wrap text-xs leading-relaxed text-foreground">
        {instructions}
      </p>
      {resources && resources.length > 0 && (
        <ul className="flex flex-col gap-0.5 text-xs text-muted-foreground">
          {resources.map((resource) => (
            <li key={resource.path} className="font-mono">
              {resource.path}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
